<div class="page-wrapper">
  <div class="login-wrapper">
    <mat-card role="group">
      <div class="login-header">
        <mat-card-title class="title">Log in </mat-card-title>
        <div class="fc-logo"></div>
      </div>
      <mat-card-content>
        <form [formGroup]="loginForm" (ngSubmit)="ngOnSubmit()">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Username</mat-label>
            <input
              matInput
              placeholder="Username"
              formControlName="userName"
              required
            />
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Password</mat-label>
            <input
              matInput
              type="password"
              placeholder="Password"
              formControlName="passWord"
              required
            />
          </mat-form-field>
          <mat-error *ngIf="errorState">{{ errorMessage }}</mat-error>
          <mat-card-actions class="card-actions">
            <button
              type="submit"
              mat-stroked-button
              color="accent"
              class="btn-block"
              [disabled]="!loginForm.valid"
            >
              Login
            </button>
          </mat-card-actions>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
  <section class="footer">
    <app-footer-component></app-footer-component>
  </section>
</div>
